import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Box from 'shopper/components/Box';
import Heading from 'shopper/components/Heading';

import Anchor from 'components/Anchor';
import Image from 'components/Image';

import { sendEvent } from 'lib/gtag';
import { getArticleImageLink, toArticleImageAltText } from 'lib/image';
import { toArticleLink } from 'lib/links';
import placeholder from 'lib/placeholder';

const RelatedArticles = ({ gaEventCategory, relatedArticles = [] }) => {
  const onRelatedArticleClick = () =>
    sendEvent({ action: 'related_click', category: gaEventCategory });

  return (
    <Box className="mb-6 p-6">
      <Heading as="span" className="mb-6" size="size5">
        {placeholder('titles.seeAlso')}
      </Heading>
      <div className="grid grid-flow-row gap-4 md:grid-cols-3">
        {relatedArticles.map(
          ({ articleId, articleSlug, articleThumbnail, articleTitle }) => (
            <NextLink
              key={articleId}
              href={toArticleLink(articleSlug)}
              prefetch={false}
              passHref
            >
              <Anchor onClick={onRelatedArticleClick}>
                <Image
                  alt={toArticleImageAltText(articleTitle)}
                  className="w-full object-fill"
                  height={180}
                  src={getArticleImageLink(articleThumbnail, 400)}
                  width={327}
                />
                <Heading className="mt-4" size="size6">
                  {articleTitle}
                </Heading>
              </Anchor>
            </NextLink>
          )
        )}
      </div>
    </Box>
  );
};

RelatedArticles.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  relatedArticles: PropTypes.arrayOf(
    PropTypes.shape({
      articleId: PropTypes.number.isRequired,
      articleDescription: PropTypes.string.isRequired,
      articleImage: PropTypes.string.isRequired,
      articleModifiedDate: PropTypes.string.isRequired,
      articlePublished: PropTypes.string.isRequired,
      articleSlug: PropTypes.string.isRequired,
      articleThumbnail: PropTypes.string.isRequired,
      articleTitle: PropTypes.string.isRequired,
      commentCount: PropTypes.number.isRequired,
      metaDescription: PropTypes.string.isRequired,
      metaTitle: PropTypes.string.isRequired,
      userDescription: PropTypes.string.isRequired,
      userName: PropTypes.string.isRequired,
      userPhoto: PropTypes.string.isRequired,
      userUsername: PropTypes.string.isRequired,
    })
  ),
};

export default RelatedArticles;
